import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-formacao',
  templateUrl: './formacao.component.html',
  styleUrls: ['./formacao.component.css']
})
export class FormacaoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
